














































import Vue from 'vue';
import Component from 'vue-class-component';
import { InjectReactive } from 'vue-property-decorator';

// Shared types
import { System } from '@coldtec/cos-types';

// Tool types
import { Labels } from '@/types';

// Store types
import { SystemSplit, ToolSpace, ToolSystem, SystemsAction } from '@/store/store.types';

// Step types
import { Step } from '@/steps/types';

/**
 *  Component that renders the heading of an overview system, including
 *  the name(s) of the space(s), an edit action, type of split,
 *  name of the system and the system's price.
 */
@Component
export default class OverviewSystemHeading extends Vue {

    @InjectReactive('toolSystem')
    private toolSystem!: ToolSystem;

    @InjectReactive('toolSpaceId')
    private toolSpaceId!: string;

    @InjectReactive('toolSpaces')
    private toolSpaces!: Array<ToolSpace>;

    @InjectReactive('system')
    private system!: System;

    /**
     *  Used to easily render the split name,
     *  based on the type of split.
     */
    private splitLabels: Labels = {
        [SystemSplit.Single]: 'Single split',
        [SystemSplit.Multi]: 'Multi split',
    };

    /**
     *  Used to get the names of the space(s) for which the system is.
     */
    private get spaceNames(): string {

        let names: Array<string> | string = this.toolSpaces.map((space: ToolSpace) => {

            return space.data.name as string;

        });

        names = names.join(', ').replace(/, ([^,]*)$/, ' en $1').toLowerCase();

        return names.charAt(0).toUpperCase() + names.slice(1);

    }

    /**
     *  Used to navigate the user back to the systems step
     *  to edit the system selection for the space(s).
     */
    private async edit(): Promise<void> {

        await this.$store.dispatch(SystemsAction.SHOW_FOR_SPACE, this.toolSpaceId);

        void this.$router.push(Step.Systems);

    }

}
